import React, { useState } from "react";
import "./VisitingCard.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css"; // Import the CSS for phone input
import axios from "axios";
import { Toast, ToastContainer } from "react-bootstrap";

const VisitingCard = () => {
  const [consentChecked, setConsentChecked] = useState(false);
  const [phone, setPhone] = useState("");
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [org, setOrg] = useState("");
  const [role, setRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const handleToastClose = () => setShowToast(false);
  const [message,setmessage]=useState("")

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
   // Set submitting to true while the API call is in progress
   const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  
    // Check if the email matches the pattern
    if (!emailPattern.test(email)) {
      setmessage("Please enter a valid email address");
      setShowToast(true)
      setName("");
      setEmail("");
      setPhone("");
      setOrg("");
      setRole("");

      setConsentChecked(false);
      return
    } 
   setIsSubmitting(true); 
    // Prepare data to send to API
    const formData = {
      name:name,
      email:email,
      phone_number:phone,
      organization_name:org,
      role:role
    };
    const isFormDataEmpty = Object.values(formData).some(value => !value);
    if(isFormDataEmpty){
      setmessage("Please Fill all the Fields!!")
      setShowToast(true)
      setIsSubmitting(false)
      return      
    }
    
    try {
      const response = await axios.post(
"https://app-acs-dev-eastus.azurewebsites.net/add_visitor",
        // "http://127.0.0.1:5000/add_visitor",
        formData
      );
      
      if(response.status === 202){
        setmessage("user alredy exist")
        setShowToast(true)
      }

      const pdfUrl = "https://blobtimesheet.blob.core.windows.net/llminsight-docs/LLMInsightAI_deck.pdf"; // Blob URL for the PDF

      // Fetch the PDF as a Blob
      const pdfResponse = await axios.get(pdfUrl, { responseType: 'blob' });
      const formDataForEmail = new FormData();
      formDataForEmail.append("application_name", "LLMinsight.ai");
      formDataForEmail.append("env_type", "dev");
      formDataForEmail.append("email_subject", "Welcome To LLMInsight.ai : Revolutionizing LLM Model Governance with the SST");
      formDataForEmail.append("html_message", `<p>Dear ${name},</p><p>Thank you for your interest in LLMInsight product. SST is pleased to share with you the LLMInsight deck, which provides an overview of LLMInsight product and its features. SST believes it will be valuable for your review and consideration.</p><p>SST assures you that using this LLMInsight – LLM Governance tool will save you around 30% to 40% of your entire spend and manage and control who will be using this LLM modules, give access through your Active Directory, log each transaction, monitor the spend, chargeback the projects and departments. Give a single chat window to execute any models, and many more features.</p><p>Please feel free to reach out if you have any questions or need additional information to our support team <a href="mailto:LLMInsightSupport@SSTGlobal.net">LLMInsightSupport@SSTGlobal.net</a></p><Best>Looking forward to your feedback.<br><br>Best regards,<br>LLMInsight Sales & Support Team<br><a href="mailto:LLMInsightSupport@SSTGlobal.net">LLMInsightSupport@SSTGlobal.net</a>`);

      formDataForEmail.append("receiver_addresses[]", email); // Add the visitor's email as a receiver

      // Append the PDF file as an attachment
      formDataForEmail.append("attachments[]", pdfResponse.data, "LLMInsight_deck.pdf");

      // Send the email with the attachment
      const emailResponse = await axios.post("https://app-acs-dev-eastus.azurewebsites.net/send_email", formDataForEmail, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (emailResponse.status === 200) {
        setmessage("Thank You for Connecting Us!!!")
        setShowToast(true)
        console.log(emailResponse.data);
      } else {
        alert("Failed to send email.");
      }
     
    } catch (error) {
      console.error("Error submitting form:", error);
      setmessage("There was an error submitting the form. Please try again.");
      setShowToast(true)
    } finally {
      setName("");
      setEmail("");
      setPhone("");
      setOrg("");
      setRole("");

      setConsentChecked(false);
      setIsSubmitting(false); // Reset submitting state
    }
  };

  // Handle consent checkbox
  const handleConsentChange = (e) => {
    setConsentChecked(e.target.checked);
  };



const downloadContact = () => {
  const vCard = `
BEGIN:VCARD
VERSION:3.0
N:Madda;Ganesh;;;
FN:Ganesh Madda (CEO)
TEL;TYPE=CELL:+1(732) 915-3055
EMAIL:Ganesh@sstus.net
ORG:SST
ADR:7 Preservation Drive Monroe, NJ, 08831
END:VCARD`;

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const encodedVCard = encodeURIComponent(vCard);
  const dataURI = `data:text/vcard;charset=utf-8,${encodedVCard}`;
  const link = document.createElement("a");
  link.href = dataURI; 
  link.download = "Ganesh_Madda.vcf"; 

  if (isIOS) {
  
    // alert("To add this vCard to your contacts, please open the file manually or use 'Open in Contacts' option.");
   
    link.click();
  } else {
   
    document.body.appendChild(link); 
    link.click(); 
    document.body.removeChild(link);
  }
};

  
  const handlePhoneChange = (newPhone) => {
    const phoneValue = newPhone ? String(newPhone) : "";
    setPhone(phoneValue);

    const valid = isValidPhoneNumber(phoneValue);
    setIsPhoneValid(valid); 
  };


  // Connect on LinkedIn
  const connectOnLinkedIn = () => {
    window.open(
      "https://www.linkedin.com/in/ganesh-madda-ceo-sst-sst-india-cio-ahs-866a481/",
      "_blank"
    );
  };

  const ShowNotification = ({message, showToast, handleToastClose}) => {
    return(
      <ToastContainer position="center" className="p-3" style={{marginTop:"50%",width:"90%"}}>
        <Toast
          onClose={handleToastClose}
          show={showToast}
          delay={5000}
          autohide
        
        >
          <Toast.Header style={{backgroundColor:"#c7dbf0"}}>
            <strong className="me-auto">Alert</strong>
          </Toast.Header>
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      </ToastContainer>
    );
  }

  return (
    <div className="container" style={{width:"100%"}} >
      <div className="row">
        {/* Left Side: Your Personal Information */}
        <div className="col-md-6" style={{ marginTop: "5%" }}>
          <div className="vc_card">
            <div className="vc_card-header">Connect with SST CEO Ganesh Madda</div>
            <div className="vc_card-body vc_contact-info">
              <p>
                <strong>Name:</strong> Ganesh Madda (CEO)
              </p>
              <p>
                <strong>Email:</strong> Ganesh@sstus.net
              </p>
              <p>
                <strong>Phone:</strong> +1(732) 915-3055
              </p>
              <p>
                <strong>Organization Name:</strong> SST
              </p>
              <p>
                <strong>Address:</strong> 7 Preservation Drive Monroe, NJ,
                08831.
              </p>

              <div className="vc_social-icons">
                <button
                  type="button"
                  className="btn vc_btn-custom mt-3"
                  onClick={downloadContact}
                >
                  Add To Phonebook
                </button>
                <button
                  type="button"
                  className="btn vc_btn-custom mt-3"
                  onClick={connectOnLinkedIn}
                >
                  Connect On LinkedIn
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Contact Form with Buttons */}
        <div className="col-md-6" style={{ marginTop: "5%" }}>
        <ShowNotification message={message} showToast={showToast} handleToastClose={handleToastClose}/>
          <div className="vc_card">
            <div className="vc_card-header">Download the LLMInsight Info</div>
            <div className="vc_card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="name" className="vc_form-label">
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    placeholder="Enter your Name"
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="vc_form-label">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter a valid email address"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="Organization Name" className="vc_form-label">
                    Organization Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={org}
                    className="form-control"
                    id="Organization Name"
                    onChange={(e) => setOrg(e.target.value)}
                    placeholder="Enter Organization Name"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="Role" className="vc_form-label">
                    Role<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={role}
                    className="form-control"
                    id="role"
                    onChange={(e) => setRole(e.target.value)}
                    placeholder="Enter your Role in Organization"
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="phone" className="vc_form-label">
                    Phone <span style={{ color: "red" }}>*</span>
                  </label>
                  <PhoneInput
                    country="us" // Default country is USA
                    value={phone}
                    onChange={handlePhoneChange} // Handle phone input change
                    preferredCountries={["us", "in", "uk"]} // Preferred countries
                    placeholder="Enter phone number"
                    className="vc_form-control"
                    required
                  />
                </div>

                <div className="mb-3 form-check" style={{padding:"0px",margin:"0px",display:"flex",alignItems:"center",}}>
                  <input
                    type="checkbox"
                    className="vc_form-check-input"
                    id="consentCheckbox"
                    checked={consentChecked}
                    onChange={handleConsentChange}
                     style={{ marginRight: "10px" }}
                  />
                  <label className="form-check-label" htmlFor="consentCheckbox" >
                    I consent to receive the deck and understand the privacy
                    policy. <span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                
                <button
                  type="submit"
                  className="btn vc_btn-custom"
                  disabled={!consentChecked}
                  onClick={handleSubmit}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </form>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  );
};

export default VisitingCard;